import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { UserPortalContext } from '../../context/appcontext';
import { makeStyles } from '@material-ui/core/styles';
import downloadIcon from '../../assets/SVGs/download-icon.svg';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import {
	UNIT,
	INVENTORY_TRENDS,
	EXCEL_INTRANSIT_INVENTORY,
	NET_SALES_CHANNEL,
	UNITS_CHANNEL,
	ITEM_NUMBER,
} from '../../constants/constant';
import {
	getWeek,
	getName,
	getColumnLabel,
	getreplenishmentColumnLabel,
	getEventTrackingDescription,
	getEventTrackingAttribute,
} from './utils';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';
import {
	ExcelFile,
	ExcelSheet,
	ExcelColumn,
} from '../../common/components/export-to-excel/index';
import { useSelector, useDispatch } from 'react-redux';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';

const useStyles = makeStyles(() => ({
	button_ellipsis: {
		width: '40px',
		height: '40px',
	},
	menuOptions: {
		fontFamily: 'Bogle-Regular',
		fontSize: '16px',
		lineHeight: '16px',
	},
}));

const getWeekFilterValue = (weekFilter) =>
	[0, 1].includes(weekFilter) ? 'busDt' : 'week_number';

const getDataColumns = ({
	data,
	isTabsTrend,
	hideTabs,
	isReplenishment,
	inTransitYear,
	chartTitle,
	weekFilter,
	selectedBtn,
	isWeekOfSupply,
	headers,
}) => {
	if (!isTabsTrend && !isReplenishment) {
		return (
			<ExcelSheet data={data} name="Data">
				<ExcelColumn
					label="Date/Week Number"
					value={getWeekFilterValue(weekFilter)}
				/>
				<ExcelColumn
					label={
						chartTitle === INVENTORY_TRENDS
							? 'Net Sales value($)'
							: getColumnLabel(chartTitle, selectedBtn, 'ty')
					}
					value="excel_ty_value"
				/>
				<ExcelColumn
					label={
						chartTitle === INVENTORY_TRENDS
							? 'On Hand value($)'
							: getColumnLabel(chartTitle, selectedBtn, 'ly')
					}
					value="excel_ly_value"
				/>
				<ExcelColumn
					label={chartTitle === INVENTORY_TRENDS ? '' : 'Change %'}
					value="excel_diff_perc"
				/>
			</ExcelSheet>
		);
	}
	if (isReplenishment) {
		return (
			<ExcelSheet data={data} name="Data">
				<ExcelColumn
					label="Date/Week Number"
					value={getWeekFilterValue(weekFilter)}
				/>
				<ExcelColumn
					label={getreplenishmentColumnLabel('ty')}
					value="excel_ty_value"
				/>
			</ExcelSheet>
		);
	}
	if (isWeekOfSupply) {
		if (chartTitle === 'Weeks of supply - Store') {
			return (
				<ExcelSheet data={data} name="Data">
					<ExcelColumn label="Week Number" value="wmYrWkNbr" />
					<ExcelColumn label="Start Date" value="wkStartDt" />
					<ExcelColumn label="End Date" value="wkEndDt" />
					<ExcelColumn label="On Hand WOS value" value="excel_onHand_wos" />
					<ExcelColumn label="On Order WOS value" value="excel_onOrder_wos" />
					<ExcelColumn label="In WHSE WOS value" value="excel_inWhse_wos" />
					<ExcelColumn
						label="In Transit WOS value"
						value="excel_inTransit_wos"
					/>
				</ExcelSheet>
			);
		} else {
			return (
				<ExcelSheet data={data} name="Data">
					<ExcelColumn label="Week Number" value="wmYrWkNbr" />
					<ExcelColumn label="Start Date" value="wkStartDt" />
					<ExcelColumn label="End Date" value="wkEndDt" />
					<ExcelColumn label="Total WOS value" value="excel_total_wos" />
					<ExcelColumn label="On Hand WOS value" value="excel_onHand_wos" />
					<ExcelColumn label="On Order WOS value" value="excel_onOrder_wos" />
				</ExcelSheet>
			);
		}
	}
	if (chartTitle === EXCEL_INTRANSIT_INVENTORY) {
		if (hideTabs) {
			return (
				<ExcelSheet data={data} name="Data">
					<ExcelColumn
						label="Date/Week Number"
						value={getWeekFilterValue(weekFilter)}
					/>
					<ExcelColumn
						label={inTransitYear('OnOrder', 'This')}
						value="excel_onorder_ty_val"
					/>
					<ExcelColumn
						label={inTransitYear('OnOrder', 'Last')}
						value="excel_onorder_ly_val"
					/>
					<ExcelColumn label="Change %" value="excel_onorder_diff_perc" />
				</ExcelSheet>
			);
		}
		return (
			<ExcelSheet data={data} name="Data">
				<ExcelColumn
					label="Date/Week Number"
					value={getWeekFilterValue(weekFilter)}
				/>
				<ExcelColumn
					label={inTransitYear('OnOrder', 'This')}
					value="excel_onorder_ty_val"
				/>
				<ExcelColumn
					label={inTransitYear('OnOrder', 'Last')}
					value="excel_onorder_ly_val"
				/>
				<ExcelColumn label="Change %" value="excel_onorder_diff_perc" />
				<ExcelColumn
					label={inTransitYear('DCtoStore', 'This')}
					value="excel_dcstore_ty_val"
				/>
				<ExcelColumn
					label={inTransitYear('DCtoStore', 'Last')}
					value="excel_dcstore_ly_val"
				/>
				<ExcelColumn label="Change %" value="excel_dcstore_diff_perc" />
				<ExcelColumn
					label={inTransitYear('InWHSE', 'This')}
					value="excel_whse_ty_val"
				/>
				<ExcelColumn
					label={inTransitYear('InWHSE', 'last')}
					value="excel_whse_ly_val"
				/>
				<ExcelColumn label="Change %" value="excel_whse_diff_perc" />
			</ExcelSheet>
		);
	}

	return (
		<ExcelSheet data={data?.data} name="Data">
			{headers?.map((column) => (
				<ExcelColumn
					key={column.value}
					label={column.excelLabel}
					value={`${column.value}Excel`}
				/>
			))}
		</ExcelSheet>
	);
};
const getMetaColumns = ({
	inventory,
	selectedTab,
	isReplenishment,
	chartTitle,
	metaData,
	item,
	itemNum,
	state,
	storeName,
	storeNum,
	isWeekOfSupply,
}) => {
	if (inventory) {
		return (
			<ExcelSheet data={metaData} name="Meta Data">
				<ExcelColumn label="Note" value="note" />
				<ExcelColumn
					label="File Generation Timestamp"
					value="fileGenerationTimestamp"
				/>
				<ExcelColumn label="Parent Company Name" value="parentCompany" />
				<ExcelColumn label="Category Name" value="catName" />
				<ExcelColumn label="Timeframe" value="timeframe" />
				<ExcelColumn label="Metric Name" value="metricName" />
			</ExcelSheet>
		);
	}

	let filterSelectionValue = 'notApplicable';
	if (selectedTab !== 'Location') {
		filterSelectionValue = 'selectedFilter';
	}
	if (chartTitle === NET_SALES_CHANNEL || chartTitle === UNITS_CHANNEL) {
		filterSelectionValue = 'notApplicable';
	}
	if (isReplenishment) {
		return (
			<ExcelSheet data={metaData} name="Meta Data">
				<ExcelColumn label="Note" value="note" />
				<ExcelColumn
					label="File Generation Timestamp"
					value="fileGenerationTimestamp"
				/>
				<ExcelColumn label="Parent Company Name" value="parentCompany" />
				<ExcelColumn label="Category Name" value="catName" />
				<ExcelColumn label="Timeframe" value="timeframe" />
				<ExcelColumn label="Metric Name" value="metricName" />
				<ExcelColumn label="Filter Selection" value={filterSelectionValue} />
				<ExcelColumn label={item ? 'Item Name' : ''} value="item" />
				<ExcelColumn label={itemNum ? ITEM_NUMBER : ''} value="itemNum" />
			</ExcelSheet>
		);
	}

	if (isWeekOfSupply) {
		return (
			<ExcelSheet data={metaData} name="Meta Data">
				<ExcelColumn label="Note" value="note" />
				<ExcelColumn
					label="File Generation Timestamp"
					value="fileGenerationTimestamp"
				/>
				<ExcelColumn label="Parent Company Name" value="parentCompany" />
				<ExcelColumn label="Category Name" value="catName" />
				<ExcelColumn label="Timeframe" value="timeframe" />
				<ExcelColumn label="Metric Name" value="metricName" />
				<ExcelColumn label="Filter Selection" value={filterSelectionValue} />
				<ExcelColumn label={itemNum ? ITEM_NUMBER : ''} value="itemNum" />
				<ExcelColumn label={item ? 'Item Name' : ''} value="item" />
			</ExcelSheet>
		);
	}

	return (
		<ExcelSheet data={metaData} name="Meta Data">
			<ExcelColumn label="Note" value="note" />
			<ExcelColumn
				label="File Generation Timestamp"
				value="fileGenerationTimestamp"
			/>
			<ExcelColumn label="Parent Company Name" value="parentCompany" />
			<ExcelColumn label="Category Name" value="catName" />
			<ExcelColumn label="Timeframe" value="timeframe" />
			<ExcelColumn label="Metric Name" value="metricName" />
			<ExcelColumn label="Filter Selection" value={filterSelectionValue} />
			<ExcelColumn label={state ? 'State Name' : ''} value="state" />
			<ExcelColumn
				label={storeName ? getName(selectedTab, 'Type') : ''}
				value="storeName"
			/>
			<ExcelColumn
				label={storeNum ? getName(selectedTab, 'Number') : ''}
				value="storeNum"
			/>

			<ExcelColumn label={item ? 'Item Name' : ''} value="item" />
			<ExcelColumn label={itemNum ? ITEM_NUMBER : ''} value="itemNum" />
		</ExcelSheet>
	);
};

const DownloadTrend = ({
	data,
	chartTitle,
	weekFilter,
	category,
	selectedFilter,
	headers,
	inventory,
	isTabsTrend,
	selectedBtn = '',
	state,
	storeName,
	storeNum,
	item,
	itemNum,
	selectedTab,
	hideTabs,
	isReplenishment,
	brandName,
	upcNumber,
	isWeekOfSupply,
	tab,
}) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const portalUserContext = React.useContext(UserPortalContext);
	const parentCompanyName = portalUserContext?.result?.companyName;
	const downloadTime = new Date().toLocaleString()?.replace(',', ' ');
	const fileName = `${chartTitle}-Scintilla-Channel Performance-${downloadTime}`;
	const open = Boolean(anchorEl);
	const classes = useStyles({});
	const dispatch = useDispatch();

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const { startWeek, endWeek } = selectedFilters;

	const kpiName = useSelector((state) => state.salesReducer.kpiName);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOnClick = () => {
		setAnchorEl(null);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.EXPORT_BUTTON,
			location: `${chartTitle}`,
		});
		const request = {
			event: 'DOWNLOADS',
			event_description: getEventTrackingDescription(chartTitle, selectedTab),
			attributes: getEventTrackingAttribute(selectedTab, kpiName, tab),
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
	};

	const metaData = [
		{
			parentCompany: parentCompanyName,
			catName: category,
			timeframe: getWeek(weekFilter, startWeek, endWeek),
			selectedFilter: selectedFilter,
			metricName: `${brandName ? brandName : ''} ${
				upcNumber ? upcNumber : ''
			} ${chartTitle} ${selectedBtn}`,
			state,
			storeName,
			storeNum,
			item,
			itemNum,
			fileGenerationTimestamp: `${downloadTime}`,
			note: `The downloaded data is governed by contract terms between Scintilla and ${parentCompanyName}`,
			notApplicable: 'Not Applicable',
		},
	];

	const inTransitYear = (tab, year) => {
		return selectedBtn === UNIT
			? `${tab} ${year} year value`
			: `${tab} ${year} year value($)`;
	};

	return (
		<>
			<IconButton
				size="medium"
				className={classes.button_ellipsis}
				onClick={handleClick}>
				<img alt="Download" src={downloadIcon} />
			</IconButton>

			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}>
				<MenuItem sx={{ padding: '6px 16px !important' }}>
					<ExcelFile
						element={
							<Typography
								className={classes.menuOptions}
								onClick={handleOnClick}>
								Download in .XLSX
							</Typography>
						}
						filename={fileName}>
						{getMetaColumns({
							inventory,
							selectedTab,
							isReplenishment,
							chartTitle,
							metaData,
							item,
							itemNum,
							state,
							storeName,
							storeNum,
							isWeekOfSupply,
						})}
						{getDataColumns({
							data,
							isTabsTrend,
							hideTabs,
							isReplenishment,
							inTransitYear,
							chartTitle,
							weekFilter,
							selectedBtn,
							isWeekOfSupply,
							headers,
						})}
					</ExcelFile>
				</MenuItem>
			</Menu>
		</>
	);
};

DownloadTrend.propTypes = {
	data: PropTypes.shape({}),
	chartTitle: PropTypes.string,
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	headers: PropTypes.array,
	category: PropTypes.string,
	selectedFilter: PropTypes.string,
	inventory: PropTypes.bool,
	isTabsTrend: PropTypes.bool,
	selectedBtn: PropTypes.string,
	state: PropTypes.string,
	storeName: PropTypes.string,
	storeNum: PropTypes.string,
	item: PropTypes.string,
	itemNum: PropTypes.string,
	selectedTab: PropTypes.string,
	hideTabs: PropTypes.bool,
	isReplenishment: PropTypes.bool,
	brandName: PropTypes.string,
	upcNumber: PropTypes.string,
	isWeekOfSupply: PropTypes.bool,
	tab: PropTypes.string,
};

DownloadTrend.defaultProps = {
	isTabsTrend: false,
	isReplenishment: false,
	brandName: '',
	selectedBtn: '',
	inventory: false,
	upcNumber: '',
	isWeekOfSupply: false,
	tab: '',
	selectedTab: '',
};

export default DownloadTrend;
